import React from 'react'

import { Faq, FaqQuestionType } from 'components'
import { BlockType, business, law, messages, principles } from './blocks'

import classes from './FAQ.module.scss'

const renderBlock = (block: BlockType[]) => {
  const renderList = (list: (string | JSX.Element)[]) => {
    return (
      <ul className={classes.list}>
        {list.map((text, i) => (
          <li key={`list__item_${i}`} className={classes.list__item}>
            {text}
          </li>
        ))}
      </ul>
    )
  }

  return (
    <>
      {block.map((el, i) => {
        if (el.type === 'title') {
          return (
            <div key={`block__el_${i}`} className={classes.title}>
              {el.content}
            </div>
          )
        }

        if (el.type === 'list' && Array.isArray(el.content)) {
          return (
            <React.Fragment key={`block__el_${i}`}>
              {renderList(el.content)}
            </React.Fragment>
          )
        }

        return (
          <p key={`block__el_${i}`} className={classes.text}>
            {el.content}
          </p>
        )
      })}
    </>
  )
}

const questions: FaqQuestionType[] = [
  {
    title: 'Принципы принятия решения',
    children: renderBlock(principles),
  },
  {
    title: 'Ответственное ведение бизнеса',
    children: renderBlock(business),
  },
  {
    title: 'Соблюдение законодательства',
    children: renderBlock(law),
  },
  {
    title: 'Корпоративная социальная ответственность и устойчивое развитие',
    children:
      'МТС Медиа учитывает в своей деятельности важность социальной ответственности и защиты окружающей среды, поэтому старается придерживаться принципов устойчивого развития: ведет бизнес этично, принимает на себя ответственность за последствия принимаемых решений и своей деятельности, а также за влияние этих последствий на общество. В своей работе компания поддерживает принцип экологической эффективности, стремясь максимально снизить влияние деятельности МТС Медиа на окружающую среду.',
  },
  {
    title: 'Сообщение о нарушениях',
    children: renderBlock(messages),
  },
]

export const FAQ: React.FC = () => {
  return <Faq questions={questions} />
}
